import {
  CONFIG_FETCH_FAILED,
  CONFIG_FETCH_SUCCESS,
  DECREMENT_SSO_REFRESH_FREQUENCY,
  RESET_SSO_REFRESH_ATTEMPTS, SET_DOMAIN_NAME,
  SET_ACCESS_TOKEN
} from '../mutation-types'
import {REFRESH_SSO_TOKEN,
  GET_CONFIG_DETAILS,
  GET_LANGUAGE_DETAILS,
  GET_ACCESS_TOKEN} from '../action-types'
import axios from 'axios'
import store from '../../store'
import qs from 'qs'

const state = {
  baseUrl: 'localhost',
  port: 8080,
  lighten4: 0.8,
  failed: true,
  error: {},
  daysForStudentAttendance: 28,
  ssoRefreshTimeout: 0,
  ssoRefreshAttempts: 0,
  initialSSORefreshAttempts: 0,
  accessToken: '',
  logoType: 'png',
  theme: '',
  helpButtonColour: '',
  helpButtonTextColour: '',
  ratingColour: ['#9e9e9e', '#f44336', '#ff9800', '#ba68c8', '#03a9f4', '#4caf50'],
  ratingLabel: ['None', 'Very Low', 'Low', 'Partial', 'Good', 'High'],
  ratingAbbreviation: ['N', 'V', 'L', 'P', 'G', 'H'],
  ratingAbbreviationReverse: [],
  ratingAbbreviationMap: {},
  ratingColorsMap: {},
  ratingLabelColorsMap: {},
  ratingsMap: {},
  ratingsLabelMap: {},
  ratingsLabelReverseMap: {},
  ratingsLabelMapAsIs: {},
  myGroupMaxStudents: 0
}

const mutations = {
  [CONFIG_FETCH_SUCCESS] (state, config) {
    Object.assign(state, config)
    state.failed = false
    state.initialSSORefreshAttempts = config.ssoRefreshAttempts

    state.ratingLabel = config.ratingLabel.split(',')
    state.ratingColour = config.ratingColour.split(',')
    state.ratingAbbreviation = config.ratingAbbreviation.split(',')
    state.ratingAbbreviationReverse = config.ratingAbbreviation.split(',').reverse()

    state.ratingColorsMap.N = state.ratingColour[0]
    state.ratingColorsMap.V = state.ratingColour[1]
    state.ratingColorsMap.L = state.ratingColour[2]
    state.ratingColorsMap.P = state.ratingColour[3]
    state.ratingColorsMap.G = state.ratingColour[4]
    state.ratingColorsMap.H = state.ratingColour[5]

    state.ratingAbbreviationMap.N = state.ratingAbbreviation[0]
    state.ratingAbbreviationMap.V = state.ratingAbbreviation[1]
    state.ratingAbbreviationMap.L = state.ratingAbbreviation[2]
    state.ratingAbbreviationMap.P = state.ratingAbbreviation[3]
    state.ratingAbbreviationMap.G = state.ratingAbbreviation[4]
    state.ratingAbbreviationMap.H = state.ratingAbbreviation[5]

    state.ratingLabelColorsMap.NONE = state.ratingColour[0]
    state.ratingLabelColorsMap.VERY_LOW = state.ratingColour[1]
    state.ratingLabelColorsMap.LOW = state.ratingColour[2]
    state.ratingLabelColorsMap.PARTIAL = state.ratingColour[3]
    state.ratingLabelColorsMap.GOOD = state.ratingColour[4]
    state.ratingLabelColorsMap.HIGH = state.ratingColour[5]

    state.ratingsMap.NONE = state.ratingAbbreviation[0]
    state.ratingsMap.VERY_LOW = state.ratingAbbreviation[1]
    state.ratingsMap.LOW = state.ratingAbbreviation[2]
    state.ratingsMap.PARTIAL = state.ratingAbbreviation[3]
    state.ratingsMap.GOOD = state.ratingAbbreviation[4]
    state.ratingsMap.HIGH = state.ratingAbbreviation[5]

    state.ratingsLabelMap.NONE = state.ratingLabel[0].split(' ').join('_')
    state.ratingsLabelMap.VERY_LOW = state.ratingLabel[1].split(' ').join('_')
    state.ratingsLabelMap.LOW = state.ratingLabel[2].split(' ').join('_')
    state.ratingsLabelMap.PARTIAL = state.ratingLabel[3].split(' ').join('_')
    state.ratingsLabelMap.GOOD = state.ratingLabel[4].split(' ').join('_')
    state.ratingsLabelMap.HIGH = state.ratingLabel[5].split(' ').join('_')

    state.ratingsLabelMapAsIs.NONE = state.ratingLabel[0]
    state.ratingsLabelMapAsIs.VERY_LOW = state.ratingLabel[1]
    state.ratingsLabelMapAsIs.LOW = state.ratingLabel[2]
    state.ratingsLabelMapAsIs.PARTIAL = state.ratingLabel[3]
    state.ratingsLabelMapAsIs.GOOD = state.ratingLabel[4]
    state.ratingsLabelMapAsIs.HIGH = state.ratingLabel[5]

    state.ratingsLabelReverseMap[state.ratingLabel[0].split(' ').join('_')] = 'NONE'
    state.ratingsLabelReverseMap[state.ratingLabel[1].split(' ').join('_')] = 'VERY_LOW'
    state.ratingsLabelReverseMap[state.ratingLabel[2].split(' ').join('_')] = 'LOW'
    state.ratingsLabelReverseMap[state.ratingLabel[3].split(' ').join('_')] = 'PARTIAL'
    state.ratingsLabelReverseMap[state.ratingLabel[4].split(' ').join('_')] = 'GOOD'
    state.ratingsLabelReverseMap[state.ratingLabel[5].split(' ').join('_')] = 'HIGH'
  },
  [CONFIG_FETCH_FAILED] (state, error) {
    state.failed = true
    state.error = error
  },
  [DECREMENT_SSO_REFRESH_FREQUENCY] (state) {
    state.ssoRefreshAttempts--
  },
  [RESET_SSO_REFRESH_ATTEMPTS] (state) {
    state.ssoRefreshAttempts = state.initialSSORefreshAttempts
  },
  [SET_DOMAIN_NAME] (state, data) {
    state.baseUrl = data.baseUrl
    state.port = data.port
  },
  [SET_ACCESS_TOKEN] (state, accessToken) {
    state.accessToken = accessToken
  }
}

const actions = {
  [REFRESH_SSO_TOKEN] (context) {
    axios({
      url: `${context.rootState.config.baseUrl}:${context.rootState.config.port}/core/auth/refresh`,
      method: 'get',
      headers: {
        'Authorization': context.rootState.profile.loginToken
      }
    })
  },
  [GET_ACCESS_TOKEN] ({rootState, commit}) {
    const data = qs.stringify({
      grant_type: 'password',
      username: 'frontend-user',
      password: 'pass'
    })
    let url = `${rootState.config.baseUrl}:${rootState.config.port}/stream-auth/oauth/token`
    // let url = `http://localhost:8081/stream-auth/oauth/token`
    axios({
      headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
      method: 'post',
      url: url,
      auth: {
        username: 'frontend-user',
        password: 'secret'
      },
      data
    }).then((res) => {
      store.commit(SET_ACCESS_TOKEN, res.data.access_token)
      store.dispatch(GET_CONFIG_DETAILS)
    })
      .catch((error) => {
        console.log(`Errored while trying to fetch access token`)
        console.error(error)
      })
  },
  [GET_CONFIG_DETAILS] ({rootState, commit}) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/config/all`,
      method: 'get',
      headers: {
        'Authorization': state.accessToken
      },
      actionData: {action: GET_CONFIG_DETAILS}
    })
      .then((res) => {
        commit(CONFIG_FETCH_SUCCESS, res.data)
        store.dispatch(GET_LANGUAGE_DETAILS)
      })
      .catch((err) => {
        console.log(`Errored while trying to fetch config from core`)
        store.commit(CONFIG_FETCH_FAILED, err)
      })
  }
}

const getters = {
  GET_STUDENT_TRUNCATION_SIZE (state) {
    return store.state.config.studentNameTruncationSize
  },
  GET_STUDENT_TRUNCATION_TYPE (state) {
    return store.state.config.studentNameTruncationType
  },
  GET_LOGO_TYPE: (state) => {
    return state.logoType
  },
  GET_LOGO_URL: (state) => {
    let logoUrl = store.state.config.logoUrl
    if (logoUrl === undefined || logoUrl === '') {
      let logoType = state.logoType
      return `/static/img/logo.${logoType}`
    } else {
      return store.state.config.logoUrl
    }
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js